/**
 * Acesso às seções do menu, derivado de `allowed_section_keys` do /auth/me.
 *
 * O backend distingue dois estados, e eles NÃO significam a mesma coisa:
 *
 *   null  — a organização não tem configuração de seções (legado), ou o
 *           usuário é da plataforma e não é escopado por organização.
 *           Mostra tudo.
 *   []    — a organização tem configuração, e ela não libera seção nenhuma.
 *           Não mostra nada.
 *
 * Tratar `[]` como `null` inverte a garantia exatamente no ajuste mais
 * restritivo: o admin desmarca todas as seções, salva, e a organização passa
 * a ver MAIS em vez de menos. Era o comportamento antes desta correção, e
 * também o efeito de um id de grupo divergir do mapa em
 * `organization_sections_service.py` — o resultado ali é `[]`, não `null`.
 */

/**
 * @returns {Set<string>|null} conjunto de chaves liberadas, ou `null` quando
 *   não há restrição declarada. Um `Set` vazio significa nenhuma seção.
 */
export function userAllowedSectionKeys(user) {
  const raw = user?.allowed_section_keys ?? user?.allowedSections ?? null;
  if (!Array.isArray(raw)) return null;
  return new Set(raw.map(String));
}

export function canAccessSectionKey(user, sectionKey) {
  if (!sectionKey) return true;
  const allowed = userAllowedSectionKeys(user);
  if (allowed === null) return true;
  return allowed.has(sectionKey);
}
